import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseEnvironmentSchema } from '../release-products/shapes';
import { ReleaseStatusSchema } from './shapes';

export const ReleaseVersionGroupSchema = z.object({
  version: z.string(),
  /** Build that stands in for the version: published ?? latest succeeded ?? latest. */
  representativeReleaseId: z.string().uuid(),
  builds: z.array(
    z.object({
      id: z.string().uuid(),
      buildNumber: z.number().int(),
      status: ReleaseStatusSchema,
    }),
  ),
});
export type ReleaseVersionGroup = z.infer<typeof ReleaseVersionGroupSchema>;

/** Visible versions, optionally scoped to a product/environment, newest first. */
export const listReleaseVersions = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/versions',
  params: z.object({}),
  query: z.object({
    productId: z.string().uuid().optional(),
    environment: ReleaseEnvironmentSchema.optional(),
  }),
  body: z.undefined(),
  response: z.object({ data: z.array(ReleaseVersionGroupSchema) }),
});
